import React, { useState, useEffect } from "react";
import { Layout, Input, Button, Collapse, Tag, InputNumber } from "antd";
import "./index.scss";
import axiosInstance from "@/axios/axiosInstance";
import _ from "lodash"; // 引入lodash来使用_.debounce
import tool from "@/assets/tool";
const { Header, Content, Footer } = Layout;

const DataGallery = () => {
  const [activeKey, setActiveKey] = useState([]);
  const [dataSet, setData] = useState([]);
  const [selectedTag, setSelectedTag] = useState("");
  const [datadTag, setSelectedDataTag] = useState("");
  const [priceRange, setPriceRange] = useState({
    minPrice: null,
    maxPrice: null,
  });
  const getData = async (min, max) => {
    let param = "";
    if (datadTag) {
      param += `dataType=${datadTag}&`;
    }
    if (selectedTag) {
      param += `fileType=${selectedTag}&`;
    }
    param += `title=${""}`;

    try {
      const response = await axiosInstance.get(
        `/dataSet/page/list?${param}&minPrice=${min || ""}&maxPrice=${
          max || ""
        }`
      );
      let compute = response.data.data;
      setData(compute);
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };
  useEffect(() => {
    getData();
    document.title =
      "渐风AI,AI数据集交易,大模型训练数据,大模型推理数据,AI数据获取,LLM数据集分享,数据在线交易";
  }, [datadTag, selectedTag]); // 空依赖项数组表示这个 effect 只在组件挂载时运行
  // 处理价格区间的变化
  const handlePriceChange = (type, value) => {
    setPriceRange((prevState) => ({
      ...prevState,
      [type]: value,
    }));
  };

  // 搜索函数（这里只是打印了价格区间，实际中可能是发送请求）
  const search = () => {
    if (priceRange.minPrice !== null && priceRange.maxPrice !== null) {
      console.log(
        `搜索价格区间: ${priceRange.minPrice} 到 ${priceRange.maxPrice}`
      );
      // 在这里发送搜索请求或执行其他操作
      getData(priceRange.minPrice, priceRange.maxPrice);
    } else {
      console.log("请输入完整的价格区间！");
    }
  };
  const handleTagClick = (tag) => {
    setSelectedTag(tag.key);
  };
  const handleDataTagClick = (tag) => {
    setSelectedDataTag(tag.key);
  };

  const fileOptions = [
    { key: "", value: "全部" },
    { key: "1", value: "压缩文件" },
    { key: "2", value: "图片文件 " },
    { key: "3", value: "音视频文件" },
    { key: "4", value: "应用程序" },
    { key: "5", value: "PDF文档" },
    { key: "6", value: "Word文档" },
    { key: "11", value: "Excel工作表" },
    { key: "22", value: "PPT幻灯片 " },
    { key: "33", value: "Flash影片" },
    { key: "44", value: "CHM文件" },
    { key: "55", value: "帮助文件" },
    { key: "66", value: "其他文件" },
  ].map((tag) => (
    <Tag
      color={selectedTag === tag.key ? "blue" : "default"}
      key={tag.key}
      onClick={() => handleTagClick(tag)}
    >
      {tag.value}
    </Tag>
  ));
  const dataOptions = [
    { key: "", value: "全部" },
    { key: "1", value: "人物形态" },
    { key: "2", value: "自然语言处理 " },
    { key: "3", value: "时尚艺术" },
    { key: "4", value: "图像识别" },
    { key: "5", value: "语音识别" },
    { key: "6", value: "机器翻译" },
    { key: "11", value: "姿态评估" },
    { key: "22", value: "自动驾驶 " },
    { key: "33", value: "农业农艺" },
    { key: "44", value: "工业制造" },
    { key: "55", value: "动物识别" },
    { key: "66", value: "无人机" },
    { key: "111", value: "机器人" },
    { key: "222", value: "文本检测 " },
    { key: "333", value: "智能硬件" },
    { key: "444", value: "智能零售" },
    { key: "555", value: "智慧城市" },
    { key: "666", value: "植物" },
    { key: "1111", value: "卫星遥感" },
  ].map((tag) => (
    <Tag
      color={datadTag === tag.key ? "blue" : "default"}
      key={tag.key}
      onClick={() => handleDataTagClick(tag)}
    >
      {tag.value}
    </Tag>
  ));

  const getLabel = (l) => {
    const bq = [
      { key: 1, value: "压缩文件" },
      { key: 2, value: "图片文件 " },
      { key: 3, value: "音视频文件" },
      { key: 4, value: "应用程序" },
      { key: 5, value: "PDF文档" },
      { key: 6, value: "Word文档" },
      { key: 11, value: "Excel工作表" },
      { key: 22, value: "PPT幻灯片 " },
      { key: 33, value: "Flash影片" },
      { key: 44, value: "CHM文件" },
      { key: 55, value: "帮助文件" },
      { key: 66, value: "其他文件" },
    ];
    let label = bq.find((v) => v.key === l).value;
    return label;
  };
  const debouncedFetchData = _.debounce(getData, 1000);
  const handleChange = (e) => {
    debouncedFetchData(e.target.value);
  };
  // const toDetail = (record) => {
  //   navigate("/dataset_detail", {
  //     state: {
  //       id: record.datasetId,
  //       profilePictureUrl: record.profilePictureUrl,
  //       nickName: record.nickName,
  //     },
  //   });
  // };
  const toDetail = (record) => {
    // 构建 URL 参数
    const params = new URLSearchParams({
      id: record.datasetId,
      profilePictureUrl: record.profilePictureUrl,
      nickName: record.nickName,
    });
    const url = `/dataset_detail?${params.toString()}`;
    window.open(url, "_blank"); // 在新窗口或新标签页中打开
  };
  return (
    <div>
      <Layout className="datalist">
        <Header className="datalist-hea">
          <div className="name">数据集交易</div>
          <Input
            placeholder="搜索"
            style={{ width: "300px", marginTop: "16px" }}
            onChange={handleChange}
            allowClear
          />
        </Header>
        <Content className="suan-cont">
          <Collapse activeKey={activeKey} onChange={setActiveKey}>
            <div className="collapse-panel">
              <div className="collapse-content">
                <div className="cont-shai">
                  <div className="name">数据集类型</div>
                  <div direction="vertical" className="chuzsz">
                    {dataOptions}
                  </div>
                </div>
                <div className="cont-shai">
                  <div className="name">文件类型</div>
                  <div direction="vertical" className="chuzsz">
                    {fileOptions}
                  </div>
                </div>
              </div>
            </div>
          </Collapse>
        </Content>
        <div className="soujg">
          <div>默认排序</div>
          <div className="pice">
            价格：
            <InputNumber
              placeholder="请输入最低价格"
              min={0} // 根据需要设置最小值
              value={priceRange.minPrice}
              onChange={(value) => handlePriceChange("minPrice", value)}
            />
            -
            <InputNumber
              placeholder="请输入最高价格"
              min={0} // 根据需要设置最小值
              value={priceRange.maxPrice}
              onChange={(value) => handlePriceChange("maxPrice", value)}
            />
            <Button type="primary" onClick={search}>
              搜索
            </Button>
          </div>
        </div>
        <Footer className="suan-foot">
          {dataSet.map((v) => (
            <div className="cont_sanx" key={v.id}>
              <div className="cont-l">
                <div className="title" onClick={() => toDetail(v)}>
                  {v.title}
                </div>
                <div>
                  <span className="xinx">{v.introduction} </span>
                </div>
                <div className="lable_name">
                  <div className="zhuangt">{getLabel(v.fileType)}</div>
                  <div className="txname">
                    <img
                      src={`/file/${v.profilePictureUrl}`}
                      alt=""
                      className="tx"
                    />
                    {v.nickName || tool.hideMiddleFour(v.phone)}
                  </div>
                </div>
              </div>
              {/* <div className="cont-r">
                <div>
                  <span className="xinx">
                    出租时长： {v.hireTime}
                    {v.hireType === 1 ? "天" : v.hireType === 2 ? "月" : "年"}
                  </span>
                </div>
                <div>
                  <div className="mone">
                    ￥ {v.hirePrice} 元 /{" "}
                    {v.hireType === 1 ? "天" : v.hireType === 2 ? "月" : "年"}
                  </div>
                  <div className="leng" onClick={() => toDetail(v)}>
                    了解更多
                  </div>
                </div>
              </div> */}
            </div>
          ))}
        </Footer>
        {/* <Footer>
          {dataSet.map((v, index) => {
            return (
              <div className="cont-san" key={v.id}>
                <div className="cont-l">
                  <div className="title" onClick={() => toDetail(v)}>
                    {v.title}
                  </div>
                  <div>
                    <span className="xinx">{v.introduction} </span>
                  </div>
                  <div className="zhuangt">
                    <div className="data-txname">
                      <img
                        src={`/file/${v.profilePictureUrl}`}
                        alt={``}
                        className="tx"
                      />
                      {v.nickName || tool.hideMiddleFour(v.phone)}
                    </div>
                  </div>
                </div>
                <div className="cont-r">
                  <div>
                    <span className="xinx">{getLabel(v.fileType)}</span>
                    <span className="xinx fileUnit">
                      {v.fileSize}
                      {v.fileUnit}
                    </span>
                  </div>
                  <div>
                    <div className="mone">￥ {v.price} 元</div>
                    <div className="leng" onClick={() => toDetail(v)}>
                      了解更多
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </Footer> */}
      </Layout>
    </div>
  );
};

export default DataGallery;
